import * as Styled from './your-topics-edit-view.styles';

export const YourTopicsEditViewSkeleton: React.FC = () => {
  return (
    <>
      <Styled.SkeletonHeadline size="medium" alignment="left" amountRows={1} />
      <Styled.SkeletonBodyCopy amountRows={2} />

      <Styled.SkeletonFormField size="medium" />
      <Styled.SkeletonFormField size="medium" />
      <Styled.SkeletonFormField size="medium" />
      <Styled.SkeletonFormField size="medium" />
    </>
  );
};
